import { Navigate, Outlet } from "react-router-dom";
import { useIsAuthenticated, useLoginUser } from "@hooks/useAuth";
import { useLoginModalActions } from "@hooks/useLoginModal";
import { useEffect } from "react";
import LoadingDots from "@components/LoadingDots";

export default function ProtectedRoute() {
  const isAuthenticated = useIsAuthenticated();
  const loginUser = useLoginUser();
  const { setOpen } = useLoginModalActions();

  useEffect(() => {
    if (!isAuthenticated) {
      setOpen(true); // 로그인 모달 열기
    }
  }, [isAuthenticated, setOpen]);

  // 1. 세션 로딩 중이거나
  // 2. 인증은 됐다고 하는데(로컬스토리지 등) 아직 유저 데이터가 스토어에 안 들어왔을 때
  // 로딩 화면을 보여줌
  if (isAuthenticated && !loginUser) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <LoadingDots />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
